import { Badge, Card, Image, Stack, Text } from "@mantine/core"
import { DesignStudioParametersToolkit } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { PublicResponses } from "@tfg/types/endpoints/public"
import {
  productCardBadgeBackgroundColorCSSVariable,
  productCardBadgeTextColorCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import hanger from "~/assets/images/hanger.svg"
import shoe from "~/assets/images/shoe.svg"
import { useProductSheetUrl } from "~/pages/Public/hooks"

type Props = {
  product: PublicResponses.ProductCard
}

export const ProductCardOneStep = ({ product }: Props) => {
  const { t } = useTranslation("public")
  const productSheetUrl = useProductSheetUrl(product.agecPopinUrl ?? "")
  return (
    <Card
      radius="md"
      withBorder
      component="a"
      href={productSheetUrl}
      target="_blank"
    >
      <Card.Section>
        <Image
          src={product.picture}
          alt={product.name}
          fit="contain"
          height={240}
          bg="#e6e6e6"
          fallbackSrc={product.type.includes("FOOTWEAR") ? shoe : hanger}
        />
      </Card.Section>
      <Stack gap={4} mt="xs" justify="space-between">
        <Text
          style={{
            fontFamily: "bebas",
          }}
          fz={16}
        >
          {product.name}
        </Text>
        <Stack gap={4} align="flex-start" justify="flex-end">
          <Badge
            bg={DesignStudioParametersToolkit.getCssVariableLiteralName(
              productCardBadgeBackgroundColorCSSVariable
            )}
            c={DesignStudioParametersToolkit.getCssVariableLiteralName(
              productCardBadgeTextColorCSSVariable
            )}
            style={{
              fontFamily: "montserrat",
            }}
          >
            {product.collection}
          </Badge>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text
              style={{
                fontFamily: "montserrat",
              }}
              fz={12}
            >
              {t("productCard.reference")}
            </Text>
            <Text
              style={{
                fontFamily: "montserrat-bold",
              }}
              fz={11}
            >
              {product.brandReference}
            </Text>
          </Stack>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text
              style={{
                fontFamily: "montserrat",
              }}
              fz={12}
            >
              {t("productCard.productType")}
            </Text>
            <Text
              style={{
                fontFamily: "montserrat-bold",
              }}
              fz={11}
            >
              {product.brandType}
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
